import { Box, Label, Select, theme } from 'pcln-design-system'
import styled from 'styled-components'

export const FlexLabel = styled(Label)`
  display: flex;
  align-items: center;
`

export const StyledSelect = styled(Select)`
  background: ${theme.colors.white};
  &::-ms-expand {
    display: none;
  }
  cursor: pointer;
`

export const StyledTSBox = styled(Box)`
  & button {
    text-align: left;
  }
`
